import * as React from "react";
import { debounce } from "lodash";

const { Component } = React;

import * as UserStore from "../users/UserStore";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";

interface OrganizationMembershipState {
    searchQuery: string;
    users: Array<any>;
    showAddModal: boolean;
    showRemoveModal: boolean;
    userToAdd: any;
    userToRemove: any;
    membershipType: string;
    source: string;
    sourceID: string;
}

interface OrganizationMembershipProps {
    organization: string;
}

let contextSubscriptionId = "";

export default class OrganizationMembership extends Component<OrganizationMembershipProps, OrganizationMembershipState> {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: "",
            users: [],
            showAddModal: false,
            showRemoveModal: false,
            userToAdd: undefined,
            userToRemove: undefined,
            membershipType: "0",
            source: "",
            sourceID: "",
        };
    }

    componentDidMount() {
        this.debouncedSearchUsers = debounce(function (query, skip, limit) {
            return UserStore.SearchAllUsers(query, skip, limit).then((response) => {
                this.setState({ users: response.data });
                return response;
            });
        }, 300);

        contextSubscriptionId = GetContext((context) => {
            UserStore.SearchUsers("", 0, 25).then((response) => {
                this.setState({ users: response.data });
                return response;
            });
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    handleQueryChange = (e) => {
        var query = e.target.value;
        this.setState({ searchQuery: query }, () => {
            if (this.state.searchQuery.length > 0) {
                this.debouncedSearchUsers(this.state.searchQuery, 0, 25);
            }
        });
    };

    handleMembershipTypeChange = (e) => {
        var type = e.target.value;
        this.setState({ membershipType: type });
    };

    debouncedSearchUsers = (query, skip, limit) => {
        return UserStore.SearchAllUsers(query, skip, limit).then((response) => {
            this.setState({ users: response.data });
            return response;
        });
    };

    toggleAddModal = () => {
        this.setState((prevState) => ({ showAddModal: !prevState.showAddModal }));
    };

    startAddUserToOrganization = (user) => () => {
        this.setState({
            userToAdd: user,
            showAddModal: true,
            source: "",
            sourceID: "",
        });
    };

    completeAddUserToOrganization = () => {
        try {
            if (this.state.userToAdd.id && this.props.organization && this.state.membershipType) {
                UserStore.AddUserToOrganization(this.state.userToAdd.id, this.props.organization, this.state.membershipType, this.state.source, this.state.sourceID).then((response) => {
                    if (response.status == 200) {
                        this.debouncedSearchUsers(this.state.searchQuery, 0, 25).then(() => {
                            this.setState({
                                showAddModal: false,
                            });
                        });
                    }
                });
            }
        } catch (e) {}
    };

    toggleRemoveModal = () => {
        this.setState((prevState) => ({ showRemoveModal: !prevState.showRemoveModal }));
    };

    startRemoveUserFromOrganization = (user) => () => {
        this.setState({
            userToRemove: user,
            showRemoveModal: true,
        });
    };

    completeRemoveUserFromOrganization = () => {
        try {
            if (this.state.userToRemove.id && this.props.organization && this.state.membershipType) {
                UserStore.RemoveUserFromOrganization(this.state.userToRemove.id, this.props.organization, this.state.membershipType).then((response) => {
                    if (response.status == 200) {
                        this.debouncedSearchUsers(this.state.searchQuery, 0, 25).then(() => {
                            this.setState({
                                showRemoveModal: false,
                            });
                        });
                    }
                });
            }
        } catch (e) {}
    };

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Search</label>
                    <div className="col-sm-9 pl-0">
                        <input type="text" className="form-control" name="search" value={this.state.searchQuery} onChange={this.handleQueryChange} />
                    </div>
                </div>
                <table className="table">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Name</th>
                            <th style={{ width: "60%" }}></th>
                        </tr>
                    </thead>
                    {this.state.users.length > 0 && (
                        <tbody>
                            {this.state.users.map((user) => {
                                var userInOrganization = user.organizationMembership.filter((o) => o.organizationID == this.props.organization).length > 0;
                                return (
                                    <tr key={user.id}>
                                        <td>
                                            {user.fullName} <span className="text-muted">({user.userName})</span>
                                        </td>
                                        <td>
                                            {!userInOrganization && (
                                                <button className="btn btn-primary btn-sm" onClick={this.startAddUserToOrganization(user)}>
                                                    Add to Organization ...
                                                </button>
                                            )}
                                            {userInOrganization && (
                                                <div>
                                                    <button className="btn btn-primary btn-sm" style={{ marginRight: "1rem" }} onClick={this.startAddUserToOrganization(user)}>
                                                        Create additional membership ...
                                                    </button>
                                                    <button className="btn btn-warning btn-sm" onClick={this.startRemoveUserFromOrganization(user)}>
                                                        Remove from Organization
                                                    </button>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    )}
                </table>
                <Modal isOpen={this.state.showAddModal} toggle={this.toggleAddModal} centered={true}>
                    <ModalHeader toggle={this.toggleAddModal}>Manage Organization Membership</ModalHeader>
                    <ModalBody>
                        {this.state.userToAdd && (
                            <div>
                                <div>Create membership for: {this.state.userToAdd.fullName}</div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Type</label>
                                    <div className="col-sm-9 pl-0">
                                        <Input type="select" name="type" value={this.state.membershipType} onChange={this.handleMembershipTypeChange}>
                                            <option value="0">Staff</option>
                                            <option value="1">Student</option>
                                            <option value="2">Parent</option>
                                            <option value="3">Guest</option>
                                        </Input>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Source</label>
                                    <div className="col-sm-9 pl-0">
                                        <Input type="text" name="type" value={this.state.source} onChange={(e) => this.setState({ source: e.target.value })}></Input>
                                        <small>https://www.scadco.co.za/?schoolid=</small>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-3 col-form-label">Source ID</label>
                                    <div className="col-sm-9 pl-0">
                                        <Input type="text" name="type" value={this.state.sourceID} onChange={(e) => this.setState({ sourceID: e.target.value })}></Input>
                                    </div>
                                </div>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" onClick={this.completeAddUserToOrganization}>
                            Add
                        </button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showRemoveModal} toggle={this.toggleRemoveModal} centered={true}>
                    <ModalHeader toggle={this.toggleRemoveModal}>Manage Organization Membership</ModalHeader>
                    <ModalBody>
                        {this.state.userToRemove && (
                            <div>
                                Confirm removing {this.state.userToRemove.fullName} <span className="text-muted">({this.state.userToRemove.userName})</span> from Organization
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" onClick={this.completeRemoveUserFromOrganization}>
                            Remove
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
